module.exports = __webpack_public_path__ + "static/img/ACV Auctions2.9dd6b7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ACV Auctions2.jpg
// module id = fIXo
// module chunks = 1